var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEquip = function SvgEquip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.16667C4.77834 2.16667 2.16667 4.77834 2.16667 8C2.16667 8.28294 2.18681 8.56117 2.22574 8.83334H7.48481L9.75448 4.294C9.96031 3.88235 10.4609 3.7155 10.8725 3.92132C11.2842 4.12715 11.451 4.62771 11.2452 5.03935L9.3482 8.83334H13.7743C13.8132 8.56117 13.8333 8.28294 13.8333 8C13.8333 4.77834 11.2217 2.16667 8 2.16667ZM13.272 10.5H8.0166C8.00501 10.5003 7.9934 10.5003 7.98178 10.5H2.72802C3.66424 12.4708 5.673 13.8333 8 13.8333C10.327 13.8333 12.3358 12.4708 13.272 10.5ZM0.5 8C0.5 3.85787 3.85787 0.5 8 0.5C12.1422 0.5 15.5 3.85787 15.5 8C15.5 12.1422 12.1422 15.5 8 15.5C3.85787 15.5 0.5 12.1422 0.5 8Z",
    fill: "#1DBADF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEquip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/equip.66e4b1d8.svg";
export { ForwardRef as ReactComponent };